import React, { Component } from "react";
import styles from "./monitoringTaskTripUnitsBar.module.scss";
import CarsPaginationSettingsPanel from "../../../sections/cars/carsPaginationSettingsPanel";
import SideBar from "../../../sides/sideBar";
import CarsTitleClosedBar from "../../../sections/cars/carsTitleClosedBar";
import SideBarInner from "../../../../shared/sideBarInner";
import CarsTitleBar from "../../../sections/cars/carsTitleBar";
import CarsSortPanel from "../../../sections/cars/carsSortPanel";
import { withCars } from "../../../../shared/containers/containerCars";
import { withUnits } from "../../../../shared/containers/containerUnits";
import CarsSecondSideBar from "../../../sections/secondSideBars/carsSecondSideBar";
import MonitoringTripUnitListWrapper from "./MonitoringTripUnitListWrapper";

class MonitoringTripUnitsBar extends Component {
  constructor(props) {
    super(props);

    this.state = { isCheck: false, toAction: [], actionDelete: false };
  }

  componentDidUpdate(preProps) {}

  onClickHandler() {}

  render() {
    return (
      <div className={styles.sideBarsWrapper}>
        <SideBar TitleClosed={<CarsTitleClosedBar />}>
          <div className={styles.userUnitsBar}>
            <SideBarInner>
              <CarsTitleBar />
            </SideBarInner>

            <SideBarInner>
              <CarsSortPanel />
            </SideBarInner>

            <SideBarInner>
              <div className={styles.inLineContainer}>
                <CarsPaginationSettingsPanel />
              </div>

              <div className={styles.container_userUnitsList}>
                <MonitoringTripUnitListWrapper />
              </div>
            </SideBarInner>
          </div>
        </SideBar>

        <CarsSecondSideBar />
      </div>
    );
  }
}

export default withCars(withUnits(React.memo(MonitoringTripUnitsBar)));
